import React, { useEffect, useRef, ChangeEvent } from 'react';
import cx from 'classnames';

import baseStyles from '../BaseInput/BaseInput.module.scss';
import styles from './Checkbox.module.scss';

export interface Props {
  children?: React.ReactNode;
  className?: Parameters<typeof cx>[0];
  disabled?: boolean;
  id: string;
  name?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  small?: boolean;
  value: boolean;
  indeterminate?: boolean;
  hideLabel?: boolean;
}

export const Checkbox: React.FC<Props> = ({
  children,
  className,
  disabled,
  id,
  name,
  onChange,
  small,
  value,
  indeterminate = false,
  hideLabel = false,
}) => {
  const checkboxRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);
  return (
    <div
      className={cx(
        baseStyles.container,
        styles.container,
        disabled && styles.disabled,
        indeterminate && styles.indeterminate,
        className,
      )}
    >
      <input
        aria-checked={value}
        checked={value}
        className={cx(styles.checkbox)}
        disabled={disabled}
        id={id}
        name={name}
        onChange={onChange}
        type='checkbox'
        ref={checkboxRef}
      />
      <label
        className={cx(
          styles.label,
          small && styles.small,
          hideLabel && styles.isHidden,
        )}
        htmlFor={id}
      >
        <span className={cx(hideLabel && styles.hideLabel)}>{children}</span>
      </label>
    </div>
  );
};

Checkbox.displayName = 'Checkbox';
export default Checkbox;
export { styles };
